
      if (import.meta?.env?.VITE_APP_NAME) document.title = import.meta.env.VITE_APP_NAME;
    